// extracted by mini-css-extract-plugin
export default {"btn":"style_btn__1Vsf1","btn_state":"style_btn_state__wTRFo","btn_active":"style_btn_active__TkrT7"};